import { render, staticRenderFns } from "./main-slide.vue?vue&type=template&id=b307c34a&scoped=true&"
import script from "./main-slide.vue?vue&type=script&lang=js&"
export * from "./main-slide.vue?vue&type=script&lang=js&"
import style0 from "./main-slide.vue?vue&type=style&index=0&id=b307c34a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b307c34a",
  null
  
)

export default component.exports